import { render, staticRenderFns } from "./DetailaLeft.vue?vue&type=template&id=2fa32886&scoped=true&"
import script from "./DetailaLeft.vue?vue&type=script&lang=js&"
export * from "./DetailaLeft.vue?vue&type=script&lang=js&"
import style0 from "./DetailaLeft.vue?vue&type=style&index=0&id=2fa32886&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa32886",
  null
  
)

export default component.exports